import fetch from "cross-fetch";

const checkAddressBalance = (address) => new Promise((resolve, reject) => {
  fetch(`https://blockchain.info/q/addressbalance/${address}?cors=true`, {
    method: "GET",
    mode: "cors",
    headers: {
      "Content-Type": "text/plain"
    },
  })
    .then(response => response.text())
    .then(text => {
      const satoshis = parseInt(text, 10);
      if(isNaN(satoshis)){
        reject('Error retrieving balance');
      }
      return satoshis;
    })
    .then(balance => resolve(balance))
    .catch((err) => reject(err));
});

const waitForFunds = (address) => new Promise((resolve, reject) => {
  const max_time = 60 * 60 * 1000; // 1 hour
  const max_error_count = 5;  // 5 errors allowed
  const max_tries = 20; // ~ 12 days at 1 sec x 2^20

  let tookTooLong = false;

  setTimeout(() => { tookTooLong = true; }, max_time);

  let tries = 0;

  let waitTime = 1000; // initially 1 second

  let errorCount = 0;

  const checkBalance = () => {
    const retry = () => {
      if(errorCount >= max_error_count) {
        return reject('Balance checking error');
      } else if(tookTooLong) {
        return reject('Balance checking timed out');
      } else if (tries >= max_tries) {
        return reject('Balance checking too many requests');
      }

      waitTime = waitTime * 2;
      setTimeout(checkBalance, waitTime);
    };

    tries = tries + 1;
    checkAddressBalance(address)
      .then(satoshis => {
        if(satoshis > 0)
        {
          resolve();
        } else if(satoshis === 0) {
          retry();
        } else {
          reject('Balance checking error');
        }
      })
      .catch(err => {
        errorCount = errorCount + 1;
        retry();
      });
  };

  checkBalance();
});

export default waitForFunds;


// WEBPACK FOOTER //
// ./src/Helpers/waitForFunds.js